export default "__VITE_ASSET__zI2i3cnk__"